import { useEffect } from 'react';
// import useTradePools from './trade/useTradePools';
// import { ReadyState } from 'react-use-websocket/dist/lib/constants';
// import useSocket from '../useSocket';
// import useMockTokenPrice from './useMockTokenPrice';
import useMockTokenStats from './useMockTokenStats';

export type TokenStatsType = {
    priceChangePercent: number;
    price: string;
};

/*
let subscribed = false;

const tokenStats: Record<string, TokenStatsType> = {};

const useTokenStats = () => {
    const { tradePools } = useTradePools();

    const { readyState, lastJsonMessage, sendMessage } = useSocket();

    // const { tokenPrice } = useTokenPrice();
    const { tokenPrice } = useMockTokenPrice();

    useEffect(() => {
        if (readyState !== ReadyState.OPEN || !tradePools || subscribed) {
            return;
        }

        if (subscribed) return;

        const paramStr = tradePools.map(
            ({ chartSymbol }) => `${chartSymbol.toLowerCase()}@ticker`
        );

        const subscribeObj = {
            method: 'SUBSCRIBE',
            params: paramStr,
            id: 2,
        };

        sendMessage(JSON.stringify(subscribeObj));

        subscribed = true;

        return () => {
            subscribed = false;
        };
    }, [readyState, tradePools, sendMessage]);

    useEffect(() => {
        if (!lastJsonMessage) return;

        const socketData = lastJsonMessage as any;

        try {
            if (socketData && socketData.type === 'ticker') {
                const { change: priceChangePercent, price, s: socketSymbol } = socketData;

                if (!priceChangePercent || !price) return;

                const lastTokenStats: TokenStatsType = {
                    priceChangePercent: parseFloat(priceChangePercent) * 100,
                    price: price.toString(),
                };

                tokenStats[socketSymbol] = lastTokenStats;
            }
        } catch (e) {
            console.error(e);
        }
    }, [lastJsonMessage]);

    // returns tokenprice if trade pools are not loaded
    // returns tokenprice + tokenStats when tokenStats is not fully loaded
    // returns tokenStats when all data is loaded
    return tokenStats &&
        tradePools &&
        tradePools.every(({ chartSymbol }) => tokenStats.hasOwnProperty(chartSymbol))
        ? tokenStats
        : tradePools
        ? tradePools.reduce((acc, { chartSymbol }) => {
              return {
                  ...acc,
                  [chartSymbol]: tokenStats[chartSymbol] ?? tokenPrice[chartSymbol],
              };
          }, {} as Record<string, TokenStatsType>)
        : tokenPrice;
};
*/

const useTokenStats = () => {
    const tokenStats = useMockTokenStats();
    return tokenStats;
};

export default useTokenStats;
